export enum AncillarieType {
  priority = "priority",
  baggage = "baggage",
}
